function getType(arg) {
  return Object.prototype.toString.call(arg);
}

/**
 * timeago date format function
 * @param  {Date} date                    格式化的时间，Date构造函数所支持的参数这里都支持
 * @param(option) {String} localesConfig  例如：'刚刚_秒以前_分钟以前_小时以前_天以前_周以前_月以前_年以前'
 * @param(option) {Array} secArray        和localesConfig相对应的时间划分尺度，默认10秒内会显示刚刚
 * @return {String}                       例如：30秒以前
 */
function timeago(date, localesConfig = '', secArray) {
  if (!date) {
    return '';
  }
  const indexMap = localesConfig.split('_'); // indexMap的length必须要比secArray的length多一个
  const SEC_ARRAY = secArray || [10, 60, 60, 24, 7, 365 / 7 / 12, 12];
  const SEC_ARRAY_LEN = SEC_ARRAY.length;

  function toInt(number) {
    return parseInt(number, 10);
  }
  // format Date / string / timestamp to Date instance.
  function toDate(input) {
    if (input instanceof Date) return input;
    return new Date(input);
  }

  // 多语言处理
  function localeProcess(number, index) {
    if (indexMap.length !== (SEC_ARRAY_LEN + 1)) {
      // 如果传入的参数不对，只返回时间差值以及当前所在的单位
      return [number, index];
    }
    if (index === 0) return indexMap[0];
    const unit = indexMap[toInt(index)];
    return `${number}${unit}`;
  }
  // format the diff second to *** time ago, with setting locale
  function formatDiff(diff) {
    let i = 1;
      // total_sec = diff = Math.abs(diff);
    // 小于10秒的话特殊处理，显示为刚刚的情况
    if (diff < SEC_ARRAY[0]) {
      return localeProcess(diff, 0);
    }
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY_LEN; i++) {
      diff /= SEC_ARRAY[i]; // eslint-disable-line no-param-reassign
    }
    diff = toInt(diff); // eslint-disable-line no-param-reassign
    return localeProcess(diff, i);
  }
  const diff = new Date() - toDate(date);
  return formatDiff(diff / 1000);
}

export default timeago;



// WEBPACK FOOTER //
// ./src/utils/timeago.js